interface IconProps { size?: number; className?: string }

/** The app's exact gauge icon, renamed only because this surface says Genius points. */
export function GeniusIcon({ size = 18, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 18.9A8.5 8.5 0 1 1 20 18.9" />
      <path d="M12 16l3-5.2" />
    </svg>
  );
}

/** The app's exact vertical cowrie-shell silhouette. */
export function CowrieIcon({ size = 18, className }: IconProps) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2.5c3.59 0 6.5 4.25 6.5 9.5s-2.91 9.5-6.5 9.5S5.5 17.25 5.5 12 8.41 2.5 12 2.5Z" />
      <path d="M10.4 6.8c-.95 1.6-1.4 3.35-1.4 5.2s.45 3.6 1.4 5.2" />
      <path d="M13.6 6.8c.95 1.6 1.4 3.35 1.4 5.2s-.45 3.6-1.4 5.2" />
    </svg>
  );
}
